import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion'

const InternalComments = ({
  inputData,
  sendinputdata,
  sendBooleanValueChangeDone,
}) => {
//   const [InternalComments, setInternalComments] = useState('')

  const handleInternalComments = event => {
    const tempInputData = { ...inputData }
    tempInputData.internalComments = event.target.value
    sendinputdata(tempInputData)
    sendBooleanValueChangeDone('internalComments', true)
  }

  return (
    <div style={{ marginTop: '10px' }}>
      <Accordion allowZeroExpanded>
        <AccordionItem>
          <AccordionItemButton>InternalComments</AccordionItemButton>
          <AccordionItemPanel>
            <div style={{ marginTop: '10px' }}>
              <label>InternalComments</label>
              <textarea
                className='rounded p-1'
                value={inputData.internalComments}
                style={{ width: '100%', marginTop: '10px' }}
                rows={12}
                cols={20}
                onChange={handleInternalComments}
              />
            </div>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  )
}

export default InternalComments
